<div flex fxLayout="row" class="row">
    <div fxFlex="25" class="pr-3 mr-3">
        <div flex fxLayout="col" class="">
            <div fxFlex="5"><span class="material-icons link" (click)="backClicked()">chevron_left</span></div>
            <div fxFlex class="text-center"><h3>{{ player.username }}</h3></div>
            <div fxFlex="5" [hidden]="1"><span class="material-icons edit" (click)="editMode=true;">edit</span></div>
        </div>
        <div class="pb-4 pt-1 text-center">
            <img ng-src src="{{ player.photo || 'assets/img/user.jpg' }}" class="img-round w-50" alt="" >
        </div>
        <div>
            <table class="table">
                <tr>
                    <td>Usuario Pilka mobile:</td>
                    <td width="100" class="text-right"></td>
                </tr>
                <tr>
                    <td>Partidos jugados:</td>
                    <td class="text-right"></td>
                </tr>
                <tr>
                    <td>Reservas realizadas:</td>
                    <td class="text-right"></td>
                </tr>
            </table>
        </div>
    </div>
    <div fxFlex="5"></div>
    <div fxFlex="40" class="p-3 mt-5">
        <form #f="ngForm">
            <div class="form-container">
                <mat-form-field>
                    <input matInput 
                            name="username" 
                            [(ngModel)]="player.username" 
                            placeholder="Nombre" 
                            [disabled]="!editMode"
                            required>
                </mat-form-field>
                <mat-form-field>
                        <input matInput 
                            name="phone" 
                            placeholder="Teléfono" 
                            [disabled]="!editMode"
                        >
                </mat-form-field>

                <mat-form-field>
                        <input matInput 
                            name="email"
                            [(ngModel)]="player.email"
                            placeholder="Email" 
                            [disabled]="!editMode"
                        >
                </mat-form-field>

                <mat-form-field>
                        <input matInput 
                            name="pais" 
                            [(ngModel)]="player.country"
                            placeholder="País" 
                            [disabled]="!editMode"
                        >
                </mat-form-field>

                <mat-form-field>
                        <input matInput 
                            name="provincia"
                            [(ngModel)]="player.state"
                            placeholder="Provincia" 
                            [disabled]="!editMode"
                        >
                </mat-form-field>

                <mat-form-field>
                        <input matInput 
                            name="city"
                            [(ngModel)]="player.city"
                            placeholder="Ciudad" 
                            [disabled]="!editMode"
                        >
                </mat-form-field>

                <mat-form-field>
                        <input class="text-left" matInput [matDatepicker]="currentDateSelector"
                                [(ngModel)]="player.birth_date" 
                                name="birth_date" 
                                [disabled]="!editMode"
                                required>
                        <mat-datepicker-toggle matSuffix [for]="currentDateSelector"></mat-datepicker-toggle>
                        <mat-datepicker #currentDateSelector disabled="false"></mat-datepicker>
                </mat-form-field>

            </div>
    
        </form>
    </div>
</div>

